var _MapComparer_selector, _MapComparer_comparer;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
/**
 * Compares objects of the same type using a custom selector and
 * a comparer for the selector's return value.
 */
export default class MapComparer {
    constructor(selector, comparer) {
        _MapComparer_selector.set(this, void 0);
        _MapComparer_comparer.set(this, void 0);
        __classPrivateFieldSet(this, _MapComparer_selector, selector, "f");
        __classPrivateFieldSet(this, _MapComparer_comparer, comparer, "f");
    }
    compare(x, y) {
        const x_value = __classPrivateFieldGet(this, _MapComparer_selector, "f").call(this, x);
        const y_value = __classPrivateFieldGet(this, _MapComparer_selector, "f").call(this, y);
        return __classPrivateFieldGet(this, _MapComparer_comparer, "f").compare(x_value, y_value);
    }
    equals(x, y) {
        const x_value = __classPrivateFieldGet(this, _MapComparer_selector, "f").call(this, x);
        const y_value = __classPrivateFieldGet(this, _MapComparer_selector, "f").call(this, y);
        return __classPrivateFieldGet(this, _MapComparer_comparer, "f").equals(x_value, y_value);
    }
    greaterThan(x, y) {
        return this.compare(x, y) > 0;
    }
    greaterThanOrEqual(x, y) {
        return this.compare(x, y) >= 0;
    }
    lessThan(x, y) {
        return this.compare(x, y) < 0;
    }
    lessThanOrEqual(x, y) {
        return this.compare(x, y) <= 0;
    }
}
_MapComparer_selector = new WeakMap(), _MapComparer_comparer = new WeakMap();
